<template>
    <div class="popupBg" @click.self="pressCancel">
        <div class="popupArea bg-lightest px-3">

            <div class="text-center fs-larger font-weight-600 p-3">
                Payments
            </div>

            <div class="col-sm-12 paymentRowsHolder">
                <div class="d-flex flex-row justify-content-between" v-for="payment in paymentsList">
                    <span class="font-weight-600">
                        <span>{{formatDateForList(payment.date)}}</span>
                        <span class="dark">{{composePaymentDetailsRow(payment)}}</span>
                    </span>
                    <span class="font-weight-600" :class="{'color-3': payment.paymentDirection==0, 'color-6': payment.paymentDirection==1}">
                        <span class="mr-2">{{payment.paymentDirection==0? '':'-'}}</span>
                        <span>{{formatPrice(payment.value) + ' ' + payment.currency }}</span>
                    </span>
                </div>
            </div>

            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-6" v-for="paymentDirection in getPaymentDirections">
                        <button class="btn widest w-100" :class="{'opacity-30':payment.paymentDirection != null && payment.paymentDirection != paymentDirection.id, 'action': paymentDirection.id == 1}" @click="showPaymentArea(paymentDirection.id)">{{paymentDirection.description}}</button>
                    </div>
                </div>
            </div>

            <div class="col-sm-12 d-flex align-items-end mb-2 justify-content-end">

                <div v-if="reservation.status == '-5'">
                    <label class="mr-3">
                        Amount to refund
                    </label>
                    <span class="fs-large font-weight-600" :class="{'color-6': refundTotalMissing < 0, 'color-3': refundTotalMissing === 0 }">{{ formatPrice(refundTotalMissing) }} €</span>
                </div>

                <div v-if="reservation.status != '-5'">
                    <label class="mr-3">
                        <span v-if="totalDue >= 0">Due to Pay</span>
                        <span v-if="totalDue < 0">Over Pay</span>
                    </label>
                    <span class="fs-large font-weight-600" :class="{'color-6': totalDue < 0 }">{{ formatPrice(totalDue) }} €</span>

                    <label class="mx-3">
                        Total
                    </label>
                    <span class="fs-large font-weight-600">{{ formatPrice(getReservationCalculations.grandTotal) }} €</span>
                </div>

            </div>

            <div v-if="showPayArea" class="mt-3">
                <div class="col-sm-12 d-flex flex-row justify-content-between">
                    <label>Select payment method</label>
                    <label>Amount</label>
                </div>

                <div class="col-sm-12 mt-3 pb-3">
                    <div class="row">
                        <div class="col-sm-9 d-flex flex-row align-items-center flex-wrap">

                            <div class="payMethod radius-normal text-center border-medium py-3 d-flex flex-column justify-content-between mr-2 mb-2 pointer" @click="selectPayMethod(payment, paymentMethod)" :class="{selected: paymentMethod.id == payment.type}" v-for="paymentMethod in getPaymentTypeListAll">
                                <div>
                                    <i v-if="paymentMethod.icon" class="ico dark fs-largest m-0" :class="paymentMethod.icon"></i>
                                    <img v-else-if="paymentMethod.img" :src="paymentMethod.img" :alt="paymentMethod.description" style="max-width: 60%;">
                                </div>
                                <span class="payeLabel darkest font-weight-600">{{paymentMethod.description}}</span>
                            </div>

                            <!-- Agent reservation -->
                            <!-- <div v-if="reservation.creatorAgent" class="payMethod radius-normal text-center border-medium py-3 d-flex flex-column justify-content-between mr-2 mb-2 pointer" @click="selectPayMethod(payment, {id: -100})" :class="{selected: -100 == payment.type}">
                                <div>
                                    <i class="ico dark fs-largest m-0 ico-people"></i>
                                </div>
                                <span class="darkest font-weight-600">Agent</span>
                            </div> -->

                            <!-- <toggle-button  v-model="payment.paymentDirection" :sync="true" :color="{checked: '#e73f47', unchecked: '#6ac951'}" :labels="{checked: 'Out', unchecked: 'In'}"/> -->

                        </div>
                        <div class="col-sm-3 d-flex align-items-start">
                            <div class="d-flex flex-row align-items-center">
                                <span class="color-6 fs-super mr-2" v-if="payment.paymentDirection == 1">-</span>
                                <input type="number" style="height: 50px;" step=".01" min="0" class="fs-largest w-100 text-right bg-lighter glued-right overflow-auto" v-model.number="payment.value" placeholder="0">
                                <div class="border-light glued-left fs-largest py-2 px-2">€</div>
                                <!-- <i class="ico ico-add fs-large color-1 mr-0 ml-3 pointer" @click="addPaymentOption" v-if="index == 0"></i>
                                <i class="ico ico-delete fs-large color-1 mr-0 ml-3 pointer" @click="removePaymentOption(index)" v-if="index > 0"></i> -->
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-sm-12 row mx-0 px-0 pb-3 border-top-light pt-3">

                    <!-- <div class="col-sm-5 d-flex align-items-center">
                        <label class="mr-2">
                            Tresurer
                        </label>
                        <div class="w-100">
                            <v-select v-if="editedTresurerList" :options="editedTresurerList" label="name" v-model="selectedTresurer" @input="treasurerChanged"></v-select>
                        </div>
                    </div> -->

                    <div class="col-sm-12 d-flex align-items-center">
                        <label class="mr-2">
                            Notes
                        </label>
                        <input type="text" class="w-100" v-model="payment.description">
                    </div>

                </div>

                <!-- <div class="col-sm-12 bg-lightest darkest d-flex flex-column px-3 radius-normal">

                    <div class="d-flex flex-row align-items-center justify-content-between w-100 pointer" @click="showBillingDetails = !showBillingDetails">
                        <span class="font-weight-600">Billing Details</span>
                        <i class="ico  fs-large dark" :class="{'ico-arrow-bottom': !showBillingDetails, 'ico-arrow-top': showBillingDetails}"></i>
                    </div>

                    <div v-if="showBillingDetails" class="row py-4">

                        <div class="col-sm-4">
                            <label>
                                VAT Number
                            </label>
                            <input type="text" class="full mb-3" v-model="reservation.billing.details.vat">
                        </div>

                        <div class="col-sm-4">
                            <label>
                                City
                            </label>
                            <input type="text" class="full mb-3" v-model="reservation.billing.details.city">
                        </div>

                        <div class="col-sm-4">
                            <label>
                                Country
                            </label>
                            <v-select :options="getCountries" v-model="selectedCountry" label="name" @input="selectedCountryChanged"></v-select>
                        </div>

                        <div class="col-sm-6">
                            <label>
                                Business name
                            </label>
                            <input type="text" class="full mb-3" v-model="reservation.billing.details.businessName">
                        </div>

                        <div class="col-sm-6">
                            <label>
                                Address
                            </label>
                            <input type="text" class="full mb-3" v-model="reservation.billing.details.address">
                        </div>

                    </div>
                </div> -->


                <div class="col-sm-12 my-2 text-right">
                    <button class="btn tertiary wider" :disabled="isSavingPayment" @click="pressCancel">Cancel</button>
                    <button class="btn primary wider ml-2" :disabled="isSavingPayment" @click="savePayment">Done</button>
                </div>
            </div>


        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { reservationsMixin } from '@/mixins/reservations'
import extendedVSelect from '@/extends/vue-select'

export default {
    data: function() {
        return {
            selectedCountry: null,
            showPayArea: false,
            payment: {
                type: 1,
                value: null,
                currency: "€",
                paymentDirection: null,
                // treasureAgentId: null,   //we can save the treasurer as an agent or supplier or user account
                // treasurerSupplier: null, //we can save the treasurer as an agent or supplier or user account
                treasurerUserAccount: null, //we can save the treasurer as an agent or supplier or user account
                description: ''
            },
            description: null,
            tempBilling: {
                promoCode: "",
                promoCodeDiscountType: null,
                promoCodeDiscountCode: null,
                discountType: 0,
                discountValue: 0,
                description: "",
                details: {
                    vat: "",
                    businessName: "",
                    address: "",
                    city: "",
                    country: 1
                },
                invoices: null,
                payments: [
                    {
                        type: {
                            id: 1,
                            description: "Cash"
                        },
                        value: null,
                        currency: "€"
                    }
                ]
            },
            tresurerArr:[],
            selectedTresurer: null,
            showBillingDetails: false,
            showNotes: false,
            myTeamMembers: [],
            isSavingPayment: false
        }
    },
    props:{
        reservation: {
            type: Object
        },
        showAddPayment: {
            type: Boolean
        }
    },
    created: function() {
        //set the discount on the temp object
        //this.tempBilling.discountValue = this.reservation.billing.discountValue;

        //set tresurer as me
        this.selectedTresurer = this.tresurerMe

        //get my team
        // this.getMyTeamMembers()

        //if reservation is canceled the amount to refund will show pre-populated
        if(this.reservation.status == '-5'){
            this.showPaymentArea(1)
            this.payment.value = this.refundTotalMissing
        }

        this.setSelectedCountry(this.reservation.billing.details.country)

        this.treasurerChanged()

    },
    mixins:[
        reservationsMixin
    ],
    computed: {
        ...mapGetters([
            'getReservation',
            'account',
            'getPaymentDirections',
            'getReservationCalculations',
            'getAgents',
            'getPaymentTypeListAll',
            'getCountries'
        ]),
        totalDue: function(){
            if(this.payment.paymentDirection == 1){
                return (this.getReservationCalculations.grandTotal - this.paid) + this.payment.value
            } else {
                return (this.getReservationCalculations.grandTotal - this.paid) - this.payment.value
            }
        },
        paymentsList: function () {
            return this.reservation.billing.payments.sort(function(a, b) {
                return a.id - b.id;
            });
        },
        // reservation: function() {
        //     return this.getReservation;
        // },
        // costTotal: function() {
        //     let total = 0;
        //     let totalWithVat = 0;
        //
        //     //ticket cost
        //     for(let personType of this.reservation.event.eventGenderPrices){
        //         total += personType.value * personType.quantity;
        //         totalWithVat += personType.valueCalculated * personType.quantity;
        //     }
        //
        //     return {
        //         total: total,
        //         totalWithVat: totalWithVat
        //     }
        //
        // },
        totalInPyamentOptions: function() {
            let total = 0;

            for(let paymentOption of this.tempBilling.payments){
                total += Number(paymentOption.value);
            }

            return total;
        },
        outstandingAmout: function() {
            return this.reservationTotalCost.withDiscount.withVat - this.totalInPyamentOptions
            // return 0
        },
        editedTresurerList: function() {
            let tresurerList = JSON.parse(JSON.stringify(this.tresurerArr));

            tresurerList.unshift(this.tresurerMe)


            return tresurerList;
        },
        tresurerMe: function() {
            return {name: this.account.name + ' (Me)', id: this.account.id}
        },
        refundTotalMissing: function () {
            return this.getReservationCalculations.grandTotal + (this.totalDue * -1)
            // return 77
        }
    },
    methods: {
        ...mapActions([
            'createNewReservation',
        ]),
        cancel: function() {
            this.close();
        },
        removePaymentOption: function(index) {
            this.tempBilling.payments.splice(index, 1)
        },
        selectPayMethod: function(payment, paymentMethod) {
            // this.payment.type = payMethod;
            payment.type = paymentMethod.id
        },
        savePayment: function() {
            if(this.payment.value != null && this.payment.value > 0){
                /*this.isSavingPayment = true
                axios.post('api/booking/addPayment', {
                    supplierId: this.account.supplierId,
                    bookingId: this.reservation.id,
                    parcels: [
                        this.payment
                    ],
                    description: this.description,
                }).then(response => {
                    if(response.status == 200){
                        this.isSavingPayment = false
                        this.payment.date = moment().format("YYYY-MM-DD hh:mm:00");

                        //add row to billing list
                        this.reservation.billingList.push({
                            date: this.payment.date,
                            description: this.description,
                            details: this.payment.details,
                            payments: [this.payment],
                        })
                        //add row to billing payemnts list to help with calculations
                        this.reservation.billing.payments.push(this.payment)

                        this.$emit('toggleAddPayment')
                    }
                })
                */
                this.payment.date = moment().format("YYYY-MM-DD hh:mm:00");

                // //add row to billing list
                // this.reservation.billingList.push({
                //     date: this.payment.date,
                //     description: this.description,
                //     details: this.payment.details,
                //     payments: [this.payment],
                // })
                //add row to billing payemnts list to help with calculations
                console.log('Here is the payment', this.payment);
                this.reservation.billing.payments.push(this.payment)
                this.$emit('toggleAddPayment')
            } else {
                this.$emit('toggleAddPayment')
            }
        },
        pressCancel: function() {
            this.$emit('toggleAddPayment')
        },
        showPaymentArea: function(direction) {
            this.payment.paymentDirection = direction
            this.showPayArea = true;
        },
        formatDateForList: function(dateTime) {
            return this.formatDateDots(dateTime)+' '+this.formatTime(dateTime)
        },
        payMethodIdToName: function(payMethodId) {
            var output = this.getPaymentTypeListAll.filter(payMethod => {
                return payMethod.id ==  payMethodId
            })

            if(output && output.length > 0){
                return output[0].description
            } else {
                return null
            }
        },
        getMyTeamMembers: function() {
            axios.get('/api/supplier/memberList', {
                params: {
                    supplierId: this.account.supplierId
                }
            }).then(response => {
                if(response.status == 200){
                    this.myTeamMembers = response.data
                }
            })
        },
        treasurerChanged: function() {
            // this will have to be updated
            // this.payment.treasurerSupplier = this.account.supplier
            this.payment.treasurerUserAccount = this.account
        },
        selectedCountryChanged: function(e) {
            this.reservation.billing.details.country = e.id
        },
        setSelectedCountry: function(countryId) {
            this.selectedCountry = this.getCountries.filter(country => {
                return country.id == countryId
            })[0]
        },
        composePaymentDetailsRow: function (payment) {

            // CASH | Description (notes) | Person name

            // if Stripe (type: -90)

            let paymentMethod = this.payMethodIdToName(payment.type)
            // let paymentMethod = payment.description? payment.description : this.payMethodIdToName(payment.type)
            let userName
            // let note = null
            let note = payment.description

            if(payment.treasurerUserAccount && payment.treasurerUserAccount.name){
                userName = payment.treasurerUserAccount.name
            } else if (payment.treasurerAgent && payment.treasurerAgent.brandName) {
                userName = payment.treasurerAgent.brandName
            } else if(payment.treasurerChannel && payment.treasurerChannel.brandName){
                userName = payment.treasurerChannel.brandName
            }

            let outputArr = []


            if(paymentMethod && payment.type != -90 || note == "" || note == null){
                outputArr.push(paymentMethod)
            }

            if(userName != undefined){
                outputArr.push(userName)
            }

            if(note){
                outputArr.push(note)
            }


            return outputArr.join(' | ')


            // let output = (paymentMethod)? paymentMethod : ''
            // output += (note)? ' | ' + note : ''
            // output += (userName != undefined)? ' | ' + userName : ''
            //
            // return output
        },
        getPaymentMethodImg: function(paymentMethod) {
            // return require('@/assets/images/paymentMethods/Logo_Redunicre.png')
            return '@/assets/images/paymentMethods/Logo_Redunicre.png'
        }
    },
    components: {
        vSelect: extendedVSelect,
    }
}
</script>

<style lang="scss" scoped>

@import '../../../assets/scss/_variables.scss';

.paymentRowsHolder{
    // min-height: 100px;
    max-height: 200px;
    overflow: auto;

    div:nth-child(odd){
        background-color: $lighter;
    }
}

.payMethod{
    width: 103px;
    height: 72px;
    position: relative;

    .payeLabel{
        position: absolute;
        bottom: 7px;
        width: 100%;
    }

    &.selected{
        border-color: $darkest !important;
        border-width: 2px !important;
    }

    &:hover{
        background-color: $lighter;
    }
}



.popupBg{
    background-color: rgba(0,0,0,0.5);
    width: 100%;
    height: 100%;
    z-index: 10;
    position: absolute;

    .popupArea{
        width: 800px;
        max-height: 100%;
        margin: 0 auto;
        overflow: auto;

    }
}



</style>



// WEBPACK FOOTER //
// AddPayment.vue?3fe9bac4